module.exports = __webpack_public_path__ + "static/progression_tree_screen-e157d6331cefe26abc6310e11a2ac6e8.png";